var faqMenus = require("../../public/faq.posts.json");

const getFaqMenus = () => {
  return faqMenus || [];
};
export default getFaqMenus;
